import React, { useEffect, useState } from "react";
import { Badge, Box, IconButton } from "@mui/material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import ModeNightIcon from "@mui/icons-material/ModeNight";
import Brightness5Icon from "@mui/icons-material/Brightness5";
import FlightIcon from "@mui/icons-material/Flight";
import LanguageIcon from "@mui/icons-material/Language";
import {
  Link,
  useMatch,
  useNavigationType,
  useResolvedPath,
} from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import "./navBar.css";
import { UserAuth } from "../context/AuthContext";
import {
  AccountBalance,
  BarChart,
  Inventory,
  Money,
  ShoppingCart,
} from "@mui/icons-material";

const NavBar = ({ check, change, countCartItems, colorMode, setColorMode }) => {
  const [auth, setAuth] = useState(false);
  const { user, logout } = UserAuth();
  const navigate = useNavigationType();

  useEffect(() => {
    user ? setAuth(true) : setAuth(false);
  }, [user]);

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
      console.log("You are logged out");
    } catch (e) {
      console.log(e.message);
    }
  };

  return (
    <Box
      display="flex"
      className="nav"
      justifyContent="space-between"
      p={0}
      //   sx={{ backgroundColor: "purple", color: "white" }}
    >
      <Link to="/">
        <Box display="flex">
          <MenuIcon sx={{ color: "white" }} />
        </Box>
      </Link>
      {auth && (
        <Box display="flex">
          <CustomLink to="/home">
            <IconButton title="Dashboard">
              <HomeOutlinedIcon className="iconColor" />
            </IconButton>
          </CustomLink>

          <CustomLink to="/inventory">
            <IconButton title="Products">
              <Inventory className="iconColor" />
            </IconButton>
          </CustomLink>
          <CustomLink to="/po">
            <IconButton title="Purchase Order">
              <FlightIcon className="iconColor" />
            </IconButton>
          </CustomLink>
          {/* <CustomLink to="/shopify">
            <IconButton title="Shopifyr">
              <LanguageIcon className="iconColor" />
            </IconButton>
          </CustomLink> */}

          <CustomLink to="/register">
            <IconButton title="register">
              <AccountBalance className="iconColor" />
            </IconButton>
          </CustomLink>

          <CustomLink to="/petty">
            <IconButton title="petty">
              <Money className="iconColor" />
            </IconButton>
          </CustomLink>

          <CustomLink to="/cart">
            <IconButton title="cart">
              <Badge badgeContent={countCartItems} color="secondary">
                <ShoppingCart className="iconColor" />
              </Badge>
            </IconButton>
          </CustomLink>

          <CustomLink to="/charts">
            <IconButton title="charts">
              <BarChart className="iconColor" />
            </IconButton>
          </CustomLink>

          {/* <IconButton title="color" onClick={() => setColorMode(!colorMode)}>
            {colorMode ? (
              <ModeNightIcon />
            ) : (
              <Brightness5Icon className="iconColor" />
            )}
          </IconButton> */}

          <CustomLink to="/settings">
            <IconButton title="Settings">
              <SettingsOutlinedIcon className="iconColor" />
            </IconButton>
          </CustomLink>

          <IconButton onClick={handleLogout} title={user && user.email}>
            <PersonOutlinedIcon sx={{ color: "green" }} />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default NavBar;

function CustomLink({ to, children, ...props }) {
  const resolvedPath = useResolvedPath(to);
  const isActive = useMatch({ path: resolvedPath.pathname, end: true });

  return (
    <li className={isActive ? "active" : ""}>
      <Link to={to} {...props}>
        {children}
      </Link>
    </li>
  );
}
